import { FC } from 'react'

import {
  PASS_SUCCESS_CREATED,
  REQUEST_SUCCESS_CREATED
} from '@/app/constants/constants'
import { PageType } from '@/components/entities/requests/model/types'
import { ButtonSkeleton } from '@/components/shared/skeleton'

type Props = {
  pageType: PageType
  isLoading: boolean
}

const RequestTitleSuccess: FC<Props> = ({ pageType, isLoading }) => {
  const title =
    pageType === PageType.Passes
      ? PASS_SUCCESS_CREATED
      : REQUEST_SUCCESS_CREATED

  if (isLoading) {
    return (
      <ButtonSkeleton className="h-[44px] w-[484px] xxs:h-[28px] xxs:w-[269px]" />
    )
  }

  return <h5 className="text-36 lg:text-28 sm:text-20">{title}</h5>
}

export { RequestTitleSuccess }
